import { render, staticRenderFns } from "./StudentLearningMapProgress.vue?vue&type=template&id=6be8c398&lang=pug&"
import script from "./StudentLearningMapProgress.vue?vue&type=script&lang=ts&"
export * from "./StudentLearningMapProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports